import _ from "lodash";
import { isSectionEmpty } from "helpers/Utils";
import { TYPE } from "components/ops-mgmt/account/custom-first-look/Constants";

// cleanup rules when saving or previewing
// remove empty arrays/objects in targeting sections
export function cleanupRule(rule) {
  const cleanedRule = _.cloneDeep(rule);
  const targetingSection = cleanedRule.targetingSection || {};

  _.forEach(targetingSection, (section, key) => {
    if (isSectionEmpty(section)) {
      delete targetingSection[key];
    } else {
      // for each non-empty section, check for empty arrays/objects inside and remove them
      _.forEach(section, (value, k) => {
        if (Array.isArray(value) && value.length === 0) {
          delete section[k];
        } else if (
          typeof value === "object" &&
          value !== null &&
          Object.keys(value).length === 0
        ) {
          delete section[k];
        }
      });
    }
  });

  // cleanup again after removing empty arrays/objects inside sections
  _.forEach(targetingSection, (section, key) => {
    if (isSectionEmpty(section)) {
      delete targetingSection[key];
    }
  });

  cleanedRule.targetingSection = targetingSection;

  return cleanedRule;
}

export function groupLabels(customSettings, searchSettings, isSearch = false) {
  const searchByLabel = _.groupBy(searchSettings, "label");
  const configsByLabel = _.groupBy(customSettings, "label");
  let labels = _.keys(configsByLabel)
    .sort()
    .map((label, i) => {
      // label could be undefined
      return {
        name: `${label === "undefined" ? "No label" : label} (${
          isSearch ? `${(searchByLabel[label] || []).length}/` : ""
        }${configsByLabel[label].length})`,
        value: label,
        numOfItems: configsByLabel[label].length,
        numOfItemsSearch: (searchByLabel[label] || []).length,
        index: label === "undefined" ? 99999 : i,
      };
    });
  labels = _.sortBy(labels, "index");

  return { labels, configsByLabel, searchByLabel };
}

export function validateRule(newRule, isAdd, ruleList = []) {
  if (!newRule.id) {
    return "ID is required";
  }
  if (isAdd && _.find(ruleList, (rule) => rule.id === newRule.id)) {
    return "ID must be unique";
  }
  if (
    !isAdd &&
    _.filter(ruleList, (rule) => rule.id === newRule.id).length > 1
  ) {
    return "ID must be unique";
  }
  if (_.isNil(newRule.enabled)) {
    return "Enabled is required";
  }
  if (!newRule.name) {
    return "Name is required";
  }
  if (!newRule.priceSection) {
    return "Pricing is required";
  } else {
    // LGO (2) and Use Brand Setting (-1) has no need for price
    if (
      newRule.priceSection.priceType !== 2 &&
      newRule.priceSection.priceType !== -1 &&
      (newRule.priceSection.price === null ||
        newRule.priceSection.price === undefined ||
        newRule.priceSection.price === "")
    ) {
      return "Price is required";
    }
  }

  if (!newRule.targetingSection || _.isEmpty(newRule.targetingSection)) {
    return "Targeting is required";
  }

  const unitIds = _.get(newRule, ["targetingSection", "inventory", "unitIds"]);

  const excludedUnitIds = _.get(newRule, [
    "targetingSection",
    "inventory",
    "excludedUnitIds",
  ]);
  const hasUnitIds = unitIds && unitIds.length > 0;
  const hasExcludeUnitIds = excludedUnitIds && excludedUnitIds.length > 0;

  // unitIds and excludeUnitIds cannot include the same unit ids
  if (hasUnitIds && hasExcludeUnitIds) {
    const duplicateIds = _.intersection(unitIds, excludedUnitIds);
    if (duplicateIds.length > 0) {
      return "Targeting units cannot be targeted in both Unit IDs and Exclude Unit IDs";
    }
  }

  return "";
}

export function validateFirstLook(newRule, isAdd, ruleList = []) {
  if (!newRule.id) {
    return "ID is required";
  }

  if (isAdd && _.find(ruleList, (rule) => rule.id === newRule.id)) {
    return "ID must be unique";
  }

  if (
    !isAdd &&
    _.filter(ruleList, (rule) => rule.id === newRule.id).length > 1
  ) {
    return "ID must be unique";
  }

  if (!newRule.name) {
    return "Name is required";
  }

  if (_.values(TYPE).indexOf(newRule.type) < 0) {
    return "Type need to be predefined value";
  }

  if (!newRule.targetingSection || _.isEmpty(newRule.targetingSection)) {
    return "Targeting is required";
  }

  const unitIds = _.get(newRule, ["targetingSection", "inventory", "unitIds"]);

  const excludedUnitIds = _.get(newRule, [
    "targetingSection",
    "inventory",
    "excludedUnitIds",
  ]);
  const hasUnitIds = unitIds && unitIds.length > 0;

  const hasExcludeUnitIds = excludedUnitIds && excludedUnitIds.length > 0;

  // unitIds and excludeUnitIds cannot include the same unit ids
  if (hasUnitIds && hasExcludeUnitIds) {
    const duplicateIds = _.intersection(unitIds, excludedUnitIds);
    if (duplicateIds.length > 0) {
      return "Targeting units cannot be targeted in both Unit IDs and Exclude Unit IDs";
    }
  }

  return "";
}

export function validateRuleCustom(newRule) {
  const custom = _.get(newRule, ["targetingSection", "customs"], []);
  return custom.length > 0;
}
